import { ConnectedPosition } from '@angular/cdk/overlay';
import { Component, HostBinding, Input, TemplateRef, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'coin-info-tooltip',
  templateUrl: './info-tooltip.component.html',
  styleUrls: ['./info-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InfoTooltipComponent {
  @Input() public html: string;
  @Input() public text: string;
  @Input() public template: TemplateRef<unknown>;
  @Input() public size = '1.13rem';
  @Input() public color: string;
  @Input() public position: 'left' | 'center' = 'center';

  @HostBinding('style') public get style(): Record<string, string> {
    return {
      width: this.size,
      height: this.size,
      fontSize: this.size,
      lineHeight: this.size,
      color: this.color
    };
  }

  private readonly overlayPositions: { [key: string]: ConnectedPosition[] } = {
    center: [{ originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'top' }],
    left: [{ originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' }]
  };

  public get overlayPosition(): ConnectedPosition[] {
    return this.overlayPositions[this.position];
  }

  public isVisible = false;

  public show(): void {
    this.isVisible = true;
  }

  public hide(): void {
    this.isVisible = false;
  }
}
